/**
 * Recruiter-facing copy for POST ai-calls/initiate gateway failures.
 * Empty/HTML 502 is not the missing-variables bug.
 */

/** Nginx / HTML gateway page (not a JSON ATS envelope). */
export function looksLikeHtmlGatewayBody(value) {
  if (value == null) return false
  if (typeof value === 'object' && !Array.isArray(value)) {
    return looksLikeHtmlGatewayBody(value.message)
      || looksLikeHtmlGatewayBody(value.error)
      || looksLikeHtmlGatewayBody(value.data)
  }
  if (typeof value !== 'string') return false
  const head = value.trim().slice(0, 400)
  if (!head) return false
  return /<!doctype|<html|<title>|<\/html>|<center>|<head>/i.test(head)
    || (/nginx/i.test(head) && /502|503|bad gateway|service unavailable/i.test(head))
}

/**
 * @param {*} raw axios response.data or a normalized envelope
 * @returns {'html'|'json'|'empty'|'text'}
 */
export function classifyInitiateErrorBody(raw) {
  if (raw == null || raw === '') return 'empty'
  if (typeof raw === 'string') {
    const trimmed = raw.trim()
    if (!trimmed) return 'empty'
    if (looksLikeHtmlGatewayBody(trimmed)) return 'html'
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) return 'json'
    return 'text'
  }
  if (typeof raw === 'object') {
    if (looksLikeHtmlGatewayBody(raw)) return 'html'
    return 'json'
  }
  return 'text'
}

/**
 * @param {number|string} httpStatus
 * @param {{ bodyKind?: string, html?: boolean, message?: string }} [details]
 */
export function formatInitiateGatewayFailure(httpStatus, details = {}) {
  const code = Number(httpStatus)
  if (code === 404) {
    return "Couldn't start the call. The initiate endpoint may not be available."
  }
  const labeled = code === 502 || code === 503
    ? `HTTP ${code}`
    : (code >= 400 ? `HTTP ${code}` : 'HTTP 502')
  const kind = details.bodyKind
    || (details.html || looksLikeHtmlGatewayBody(details.message) ? 'html' : '')
  if (kind === 'html') {
    return `${labeled}: ATS returned an HTML error page instead of JSON. The initiate hop failed before Indus accepted the call — this is not a missing-variables problem. Ask ATS to inspect the initiate log and forward the Indus body as-is.`
  }
  const jsonMsg = String(details.message || '').trim()
  if (kind === 'json' && jsonMsg && !/^(502|503|bad gateway|service unavailable)$/i.test(jsonMsg)) {
    return `${labeled}: ${jsonMsg}`
  }
  return `${labeled}: Indus/ATS gateway failed on initiate. The calling service did not complete — this is not a missing-variables problem. Check this agent’s DID and Indus Config, or ask ATS/Indus to inspect the initiate log.`
}
